import { css } from '@emotion/core';

export const $warningHeading = ({ colors, typography }) => [
  typography.family.circular,
  typography.size.L,
  css`
        color: ${colors.status.warning[500]}
    `
];
